import { createFileRoute } from '@tanstack/react-router';

import { EventPaymentHistoryPage } from '~features/events/ui/event-payment-history-page';

const Component = () => {
  const { eventId } = Route.useParams();
  return <EventPaymentHistoryPage eventId={eventId} />;
};

export const Route = createFileRoute('/_auth/_layout/events/$eventId/payments')(
  {
    component: Component,
  },
);
